import { isUrlInDomainList } from '@/hooks/useRequiredInterceptor';
import axios from 'axios';
import React from 'react';

export const useContactResetInterceptor = ({
  onReset,
  trustedDomains,
  log = console.log,
}: {
  onReset: () => void;
  trustedDomains: string[];
  log?: (...args: any[]) => void;
}) => {
  /**
   * Interceptor
   *
   * Validates trusted domains and then call reset
   */
  React.useEffect(() => {
    const ejectId = axios.interceptors.request.use(async (config) => {
      if (!isUrlInDomainList(config.url, trustedDomains)) return config;

      onReset();

      return config;
    });

    return () => {
      axios.interceptors.request.eject(ejectId);
    };
  }, [log, trustedDomains, onReset]);
};
